'use client';
import * as Sentry from '@sentry/browser';
import Image from 'next/image';

import Button from '@components/Button/next';
import { Layout } from '@components/formStyles';
import Typography from '@components/Typography';

import { ButtonGroups, Wrapper } from './styled';

export type ServerErrorProps = {
  eventId?: string | null;
  error?: string | null;
};

const InternalServerError = ({ eventId, error }: ServerErrorProps) => {
  return (
    <Layout>
      <Wrapper>
        <Image
          src='/static/images/internal_server_error.webp'
          alt='Çalışmalar devam ediyor'
          width={300}
          height={265}
        />
        <Typography as='h1' weight='Bold' variant='Title2'>
          Setur
        </Typography>

        <Typography as='p' variant='caption2' color='D500'>
          İşlemlerinize şu anda devam edemiyoruz.
        </Typography>

        <Typography as='p' variant='caption2' color='D500'>
          Dilerseniz işlemlerinize Çağrı Merkezimiz ile devam edebilirsiniz.
        </Typography>

        <Typography as='p' variant='caption2' color='D500'>
          Anlayışınız için teşekkürler.
        </Typography>
        <Typography as='p' weight='Bold' variant='caption2' color='D500'>
          {error}
        </Typography>
        <ButtonGroups>
          <Typography
            as='a'
            href='tel:4442822'
            style={{ marginBottom: '15px' }}
            color='tomato'
            variant='caption2'
          >
            444 28 22
          </Typography>

          <Button onClick={() => (window.location.href = '/')}>
            Anasayfaya Dön
          </Button>

          {eventId && (
            <Button
              variant='Secondary'
              onClick={() =>
                Sentry.showReportDialog({
                  eventId: eventId,
                  successMessage: 'Geri bildiriminiz için teşekkürler!',
                  title: 'Geri bildiriminizi paylaşın',
                  labelName: 'İsminiz',
                  labelEmail: 'E-posta adresiniz',
                  labelComments: 'Geri bildiriminiz',
                  subtitle:
                    'Müşteri aydınlatma metnine buradan ulaşabilirsiniz: https://www.setur.com.tr/kurumsal/kvkk',
                  subtitle2: '',
                })
              }
              style={{
                fontSize: '16px',
              }}
            >
              Geri Bildiriminizi Paylaşın
            </Button>
          )}
        </ButtonGroups>
      </Wrapper>
    </Layout>
  );
};

export default InternalServerError;
